import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { ServiceConfig } from './service-config';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class PostService {
  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/post/';
  private baseUrlFollowReport = this.host + '/api/follow-report/';
  private data: any;
  options = {};
  headers: Headers;

  constructor(private http: Http,private httpClient: HttpClient,private toastrService: ToastrService) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'   
     });

  }



  private processResponse(res: any, url: string) {
    // if(res.processAccount){
    //   let account = localStorage.getItem('currentSmmAccount') !== undefined && localStorage.getItem('currentSmmAccount') !== 'undefined' ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
    //   if(account.username!=res.processAccount){
    //     this.toastrService.error("Bài viết đang được xử lý bởi "+res.processAccount+" !","Thông báo!");
    //   }
    // }
  }
  public getTiktokVideoLink(link) {
    let url = this.baseUrl + 'getTiktokLink?token=' + this.data.token;   
    return this.httpClient.post<any>(url, {link : link});
  }

  public getById(id: String, body)
  {
    //thanh dv
    let url = this.baseUrl + id + '/findPostByIdComment?token=' + this.data.token;
     //console.log(url);
    return this.httpClient.post<any>(url, body);
  }

  public updatePostSentiment(body){
    let url = this.baseUrl + 'updatePostSentiment?token=' + this.data.token;   
    return this.httpClient.post<any>(url, body); 
  }
  public updateFields(body){
    let url = this.baseUrl + 'updateFields?token=' + this.data.token;   
    return this.httpClient.post<any>(url, body); 
  }


  public updateCommentInPostSentiment(body){
    let url = this.baseUrl + 'updateCommentInPostSentiment?token=' + this.data.token;   
    return this.httpClient.post<any>(url, body); 
  }

  public createFollowReportItem(body) {
    let url = this.baseUrlFollowReport + 'create?token=' + this.data.token;   
    return this.httpClient.post<any>(url, body); 
  }
  public removeFollowReportItem(body) {
    let url = this.baseUrlFollowReport + 'removeFollow?token=' + this.data.token;   
    return this.httpClient.post<any>(url, body); 
  }
  public create(post) {
    let url = this.baseUrl + 'add?token=' + this.data.token;

    this.httpClient.post<any>(url, post._source)
      .subscribe(
        res => {
          this.processResponse(res, url);
            post._source.isRead = 1;
            post._source.isProcessed = 1;
        }
      );
  }

  public upsert(post) {
    let url = this.baseUrl + 'upsert?token=' + this.data.token;

    this.httpClient.post<any>(url, post)
      .subscribe(
        res => this.processResponse(res, url)
      );
  }

  public update(post, callback = undefined) {
    let url = this.baseUrl + 'update?token=' + this.data.token;

    this.httpClient.post<any>(url, post)
      .subscribe(
        res => {
          this.processResponse(res, url);
          callback();
        }
      );
  }

  public updateBatch(body, callback = undefined) {
    let url = this.baseUrl + 'updateStatusBatch?token=' + this.data.token;

    this.httpClient.post<any>(url, body)
      .subscribe(
        res => {
          this.processResponse(res, url);
          callback();
        }
      );
  }

  public refreshPost(post, callback = undefined) {
    let url = this.host + '/api/FBPriority/refreshPost?token=' + this.data.token;

    this.httpClient.post<any>(url, {id: post.docId})
      .subscribe(
        res => {
          this.processResponse(res, url);
          callback(res.data);
        }
      );
  }

  public addFollowPost(docIds: Array<any>, callback = undefined) {
    if(docIds.length == 0) {
      return;
    }

    let url = this.host + '/api/FBPriority/addFollow?token=' + this.data.token;

    let body = {
      ids: docIds,
      type: "post"
    };

    this.httpClient.post<any>(url, body)
      .subscribe(
        res => this.processResponse(res, url)
      );
  }

  public removeFollowPost(docIds: Array<any>, callback = undefined) {
    if(docIds.length == 0) {
      return;
    }

    let url = this.host + '/api/FBPriority/removeFollow?token=' + this.data.token;

    let body = {
      ids: docIds,
      type: "post"
    };

    this.httpClient.post<any>(url, body)
      .subscribe(
        res => this.processResponse(res, url)
      );
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/post.service.ts